import { useLang } from "hooks/useLang";
import ticketNotFound from "lottiefiles/no_ticekts_found.json"
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

const NoTicketsMessage = ({ messageKey }) => {
    const { t } = useLang()

    return (
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-5 p-5">
            <Lottie
                animationData={ticketNotFound}
                className="h-[180px] w-[180px] md:h-[230px] md:w-[230px]"
            />
            <h1 className="text-center text-lg font-medium capitalize md:text-3xl">
                {t(messageKey)}
            </h1>
        </div>
    )
}
export default NoTicketsMessage
